
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/762d80b7c7adfcf595b078093ca9b503.jpg"
          alt="Coastal lighthouse with sailboat named Journey, sun over aqua waters and sandy beach"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="flex items-start justify-between gap-12">
          <div className="flex-1">
            <h1 className="text-white mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              <div className="text-7xl font-bold mb-2">Live Your</div>
              <div className="text-7xl font-bold mb-2 ml-12">Best Life</div>
              <div className="text-7xl font-bold ml-24">By The Shore</div>
            </h1>
          </div>

          <div className="w-[35%] mt-32">
            <p className="text-white text-lg font-light mb-8 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
              Experience transformative healing in a serene coastal environment where professional care meets the calming power of the ocean.
            </p>
            <button
              onClick={scrollToContact}
              className="bg-[#2C5F7C] text-white px-12 py-4 rounded-full text-base font-medium hover:bg-[#1e4456] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Begin Your Journey
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
